import {
  Directive,
  Output,
  EventEmitter,
  HostListener,
  ElementRef
} from '@angular/core';

@Directive({
  selector: '[appDraggable]',
  standalone: false
})
export class DraggableDirective {
  @Output() dragStart = new EventEmitter<PointerEvent>();
  @Output() dragEnd = new EventEmitter<PointerEvent>();
  @Output() dragMove = new EventEmitter<PointerEvent>();

  private drawing = false;
  private initialPointerEvent: PointerEvent;

  constructor(private el: ElementRef) { }

  @HostListener('pointerdown', ['$event'])
  onPointerDown(event: PointerEvent) {
    this.drawing = event.buttons === 1;
    if (!this.drawing) {
      this.initialPointerEvent = null;
      return;
    }

    this.initialPointerEvent = event;
    this.dragStart.emit(event);
    return this.stopEventPropagation(event);
  }

  @HostListener('document:pointerup', ['$event'])
  onPointerUp(event: PointerEvent) {
    if (!this.drawing) {
      return;
    }

    this.initialPointerEvent = null;
    this.drawing = false;
    this.dragEnd.emit(event);
    return this.stopEventPropagation(event);
  }

  @HostListener('document:pointermove', ['$event'])
  onPointerMove(event: PointerEvent) {
    if (!this.drawing) {
      return;
    }

    // If no button clicked, reset to initial position
    if (event.buttons !== 1) {
      this.onPointerUp(this.initialPointerEvent);
      return;
    }

    this.dragMove.emit(event);
    return this.stopEventPropagation(event);
  }

  private stopEventPropagation(event: PointerEvent): boolean {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.cancelBubble = true;
    event.returnValue = false;
    return false;
  }
}
